var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyTorchLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "488px",
    height: "121px",
    viewBox: "0 0 488 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M63.1 28.3 L56.5 34.9 C67.3 45.7 67.3 63.1 56.5 73.7 45.7 84.5 28.3 84.5 17.7 73.7 6.9 62.9 6.9 45.5 17.7 34.9 L34.8 17.8 37.2 15.4 37.2 2.5 11.4 28.3 C-3 42.7 -3 65.9 11.4 80.3 25.8 94.7 49 94.7 63.1 80.3 77.5 65.8 77.5 42.7 63.1 28.3 Z",
    fill: "#ee4c2c",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1",
    d: "M55 21.9 C55 24.551 52.851 26.7 50.2 26.7 47.549 26.7 45.4 24.551 45.4 21.9 45.4 19.249 47.549 17.1 50.2 17.1 52.851 17.1 55 19.249 55 21.9 Z",
    fill: "#ee4c2c",
    fillOpacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "group-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M129.8 61.3 L118.7 61.3 118.7 89.8 110.3 89.8 110.3 8.7 130.7 8.7 C152 8.7 162.2 19.2 162.2 33.9 162.5 52 149.9 61.3 129.8 61.3 Z M130.7 16.8 C129.8 16.8 119 16.8 119 16.8 L119 54.1 130.4 53.8 C145.7 53.5 154.1 47.5 154.1 34.9 154.1 23.1 145.7 16.8 130.7 16.8 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M199.8 89.5 L195 102.4 C189.6 116.8 183.9 121 175.8 121 171.3 121 168 119.8 164.4 118.3 L166.8 110.8 C169.5 112.3 172.5 113.5 175.8 113.5 180.3 113.5 183.6 111.1 188.1 99.7 L192 89.2 168.9 30.6 177.6 30.6 196.2 79.6 214.5 30.6 222.9 30.6 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M250.3 16.8 L250.3 90.1 241.9 90.1 241.9 16.8 213.4 16.8 213.4 9 278.6 9 278.6 16.8 C278.5 16.8 250.3 16.8 250.3 16.8 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M302.3 91.6 C285.8 91.6 273.8 79.3 273.8 60.4 273.8 41.5 286.4 28.9 303.2 28.9 320 28.9 331.7 41.2 331.7 60.1 331.4 79 318.8 91.6 302.3 91.6 Z M302.6 36.4 C290 36.4 281.9 46.3 281.9 60.4 281.9 74.8 290.3 84.7 302.9 84.7 315.5 84.7 323.6 74.8 323.6 60.7 323.6 46 315.2 36.4 302.6 36.4 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M351.8 90.1 L343.7 90.1 343.7 30.6 351.8 28.8 351.8 41.4 C355.7 33.9 361.4 28.8 369.2 28.8 373.1 28.8 376.7 30 379.7 31.5 L377.6 39 C374.9 37.5 371.9 36.3 368.6 36.3 362.3 36.3 356.6 41.1 351.8 51.6 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M411.3 91.6 C393.3 91.6 382.2 78.7 382.2 60.4 382.2 41.8 394.5 28.9 411.3 28.9 418.5 28.9 424.8 30.7 429.9 34 L427.8 41.2 C423.3 38.2 417.6 36.4 411.3 36.4 398.4 36.4 390.6 46 390.6 60.1 390.6 74.5 399 84.1 411.6 84.1 417.6 84.1 423.6 82.3 428.1 79.3 L429.9 86.8 C424.5 89.8 418.2 91.6 411.3 91.6 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M479.5 90.1 L479.5 51.6 C479.5 41.1 475.3 36.6 466.9 36.6 460 36.6 453.4 40.2 448.6 45 L448.6 90.1 440.5 90.1 440.5 2.7 448.6 0.9 448.6 38.5 C454.9 32.2 462.7 29.2 469.3 29.2 480.7 29.2 487.9 36.7 487.9 49.6 L487.9 90.2 479.5 90.2 Z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyTorchLogoBlack);
export default __webpack_public_path__ + "static/media/PyTorch_logo_black.afdea86e3f40a16754d957216f9e57f1.svg";
export { ForwardRef as ReactComponent };